export default __webpack_public_path__ + "static/media/a017-line2.75d7cc7d.svg";